<template>
  <v-app>
    <v-fade-transition mode="out-in">
      <router-view :key="$route.fullPath" />
    </v-fade-transition>
  </v-app>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100..900&display=swap');
#app {
  font-family: 'Noto Sans KR', sans-serif;
  background-color: rgba(37, 36, 64, 1);
}
</style>
